import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HtmlParseService } from '@commons/html-parser/html-parse.service';

@NgModule({
  imports: [CommonModule],
  providers: [HtmlParseService],
})
export class HtmlParserModule {}
